import React, { useState } from "react";
import { IoStar } from "react-icons/io5";
import { IoHome } from "react-icons/io5";
import './styles.css';

const HomePage = ({ onComplete, onBack }) => {
  const [funValue, setFunValue] = useState(60);
  const [bondingValue, setBondingValue] = useState(60);
  const [learningValue, setLearningValue] = useState(60);
  const [upgreading, setUpgrading] = useState(true);

  const handleStarClick = () => {
    setUpgrading((prevState) => !prevState);
  };

  const funSegments = [
    { min: 0, max: 20, opacity: 0.2, icon: "🤔" },
    { min: 20, max: 40, opacity: 0.4, icon: "🧐" },
    { min: 40, max: 60, opacity: 0.6, icon: "🧠" },
    { min: 60, max: 80, opacity: 0.8, icon: "🧑‍🔬" },
    { min: 80, max: 100, opacity: 1, icon: "🧙‍♀️" },
  ];

  const bondingSegments = [
    { min: 0, max: 20, opacity: 0.2, icon: "🖇️" },
    { min: 20, max: 40, opacity: 0.4, icon: "🪇" },
    { min: 40, max: 60, opacity: 0.6, icon: "🫶" },
    { min: 60, max: 80, opacity: 0.8, icon: "❤️" },
    { min: 80, max: 100, opacity: 1, icon: "❤️‍🔥" },
  ];

  const learningSegments = [
    { min: 0, max: 20, opacity: 0.2, icon: "🙂" },
    { min: 20, max: 40, opacity: 0.4, icon: "😄" },
    { min: 40, max: 60, opacity: 0.6, icon: "🥳" },
    { min: 60, max: 80, opacity: 0.8, icon: "🤩" },
    { min: 80, max: 100, opacity: 1, icon: "😱" },
  ];

  const getCurrentSegment = (value, segments) => {
    return segments.find(
      (segment) => value >= segment.min && value <= segment.max
    );
  };

  const currentFunSegment = getCurrentSegment(funValue, funSegments);
  const currentBondingSegment = getCurrentSegment(
    bondingValue,
    bondingSegments
  );
  const currentLearningSegment = getCurrentSegment(
    learningValue,
    learningSegments
  );

  const createSegmentedBackground = (value, segments, activeColor) => {
    const totalSegments = segments.length;
    let background = [];

    segments.forEach((segment, index) => {
      const segmentStart = (index / totalSegments) * 100;
      const segmentEnd = ((index + 1) / totalSegments) * 100;

      if (value >= segment.max) {
        background.push(
          `${activeColor} ${segment.opacity}) ${segmentStart}% ${segmentEnd}%`
        );
      } else if (value >= segment.min && value <= segment.max) {
        const percentage = (value - segment.min) / (segment.max - segment.min);
        const gradientEnd =
          segmentStart + (segmentEnd - segmentStart) * percentage;
        background.push(
          `${activeColor} ${segment.opacity}) ${segmentStart}% ${gradientEnd}%`
        );
        background.push(
          `rgba(200, 200, 200, 0.4) ${gradientEnd}% ${segmentEnd}%`
        );
      } else {
        background.push(
          `rgba(200, 200, 200, 0.4) ${segmentStart}% ${segmentEnd}%`
        );
      }
    });

    return `linear-gradient(90deg, ${background.join(", ")})`;
  };

  const handleSliderMove = (e, setValue) => {
    const slider = e.currentTarget;
    const rect = slider.getBoundingClientRect();
    const x =
      "touches" in e ? e.touches[0].clientX - rect.left : e.clientX - rect.left;
    const percentage = Math.min(Math.max((x / rect.width) * 100, 0), 100);

    const step = 20;
    const snappedValue = Math.round(percentage / step) * step;

    setValue(snappedValue);
  };

  return (
    <div className="w-full mx-auto h-screen bg-[#EEEEEE] flex flex-col">
      {/* Header */}
      <header className="px-4 pt-10 flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <span className="text-[16px] text-[#1E0A1E] font-bold font-space-grotesk flex items-start">
            <img alt="fire" className="pr-1" src={"images/fire.svg"} />
            003
          </span>
          <span className="text-[12px] text-[#1E0A1E] font-medium font-space-grotesk">
            Jams
          </span>
        </div>
        <h1 className="text-[16px] text-[#1E0A1E] font-normal font-space-grotesk">
          Battenburgers
        </h1>
        <div className="flex items-center space-x-1">
          <span className="text-[16px] text-[#1E0A1E] font-bold font-space-grotesk">
            00023
          </span>
          <span className="text-sm">
            <IoStar />
          </span>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 px-4 pt-4 pb-16 flex flex-col">
        {/* Gradient Circle */}

        {/* Sliders Card */}
        <div
          className="bg-[#FFFFFF] rounded-[2rem] p-[2.5rem] pt-[20px] pb-[40px] shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"

        >
          <div className="flex text-left" style={{transform: 'translateX(-24px)'}}>
            <p className=" flex h-[30px] w-[30px] justify-center items-center text-[16px] font-space-grotesk p-2 bg-[#000] rounded-full text-[#EEEEEE] font-bold shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]">
              2
            </p>
            <p  className="flex justify-center items-center bg-[#EEEEEE] rounded-full text-[10px] ml-2 text-[#1E0A1E] p-2 font-space-grotesk font-medium">
              Free Famjams left
            </p>
          </div>

          <div
            style={{ margin: "0 auto", width: "16rem", height: "16rem" }}
            className="relative  flex items-center justify-center rounded-full mb-8"
          >
            <div
              className="absolute inset-0 rounded-full flex items-center justify-center overflow-hidden mt-2"
              onClick={handleStarClick}
              role="button"
              tabIndex={0}
              aria-label="Toggle upgrade state"
            >
              {upgreading ? (
                <>
                  <img
                    src="/images/newfam.svg"
                    alt="logo"
                    className=" shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
                  />

                </>
              ) : (
                <>
                  <img
                    src="/images/nonupgratestar.png"
                    alt="Star"
                    className="w-full h-full object-cover rounded-full"
                  />
                  <div className="absolute text-center rounded-full">
                    <p className="text-[16px] text-[#1E0A1E] font-young-serif font-normal mb-2">
                      Next Famjam
                    </p>

                    <p className="text-[40px] text-[#1E0A1E] font-young-serif font-normal mb-2">
                      Tomorrow
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
          <p className="text-[20px] pt-2 leading-[28px] font-normal font-young-serif pb-2 text-[#3A1A1A] text-center">
            Tweak your jam
          </p>
          <div className="w-full flex flex-col gap-[2.5rem]">
            {/* Fun Slider */}
            <div className="flex flex-col items-center w-full">
              <label className="text-[12px] leading-[16px] font-normal font-young-serif text-[#3A1A1A] mb-4">
                Fun
              </label>
              <div
                className="relative flex items-center w-full"
                onMouseDown={(e) => handleSliderMove(e, setFunValue)}
                onTouchMove={(e) => handleSliderMove(e, setFunValue)}
              >
                <div
                  className="absolute left-0 top-1/2 transform -translate-y-1/2 h-4 w-full rounded-full"
                  style={{
                    background: createSegmentedBackground(
                      funValue,
                      funSegments,
                      "rgba(254, 163, 117,"
                    ),
                  }}
                ></div>
                <input
                  type="range"
                  min="0"
                  max="100"
                  step="20"
                  value={funValue}
                  onChange={(e) => setFunValue(parseInt(e.target.value))}
                  className="relative appearance-none w-full h-4 bg-transparent outline-none"
                />
                <div
                  className="absolute top-1/2 transform -translate-y-1/2 -translate-x-1/2 flex items-center justify-center h-12 w-12 rounded-full shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
                  style={{
                    left: `${funValue}%`,
                    backgroundColor: "#FEA375",
                  }}
                >
                  <span
                    role="img"
                    aria-label="Fun Emoji"
                    className="text-[33px]"
                  >
                    {currentFunSegment.icon}
                  </span>
                </div>
              </div>
            </div>

            {/* Bonding Slider */}
            <div className="flex flex-col items-center w-full">
              <label className="text-[12px] leading-[16px] font-normal font-young-serif text-[#3A1A1A] mb-4">
                Bonding
              </label>
              <div
                className="relative flex items-center w-full"
                onMouseDown={(e) => handleSliderMove(e, setBondingValue)}
                onTouchMove={(e) => handleSliderMove(e, setBondingValue)}
              >
                <div
                  className="absolute left-0 top-1/2 transform -translate-y-1/2 h-4 w-full rounded-full"
                  style={{
                    background: createSegmentedBackground(
                      bondingValue,
                      bondingSegments,
                      "rgba(246, 179, 246,"
                    ),
                  }}
                ></div>
                <input
                  type="range"
                  min="0"
                  max="100"
                  step="20"
                  value={bondingValue}
                  onChange={(e) => setBondingValue(parseInt(e.target.value))}
                  className="relative appearance-none w-full h-4 bg-transparent outline-none"
  style={{ WebkitAppearance: 'none', appearance: 'none' }}
                />
                <div
                  className="absolute top-1/2 transform -translate-y-1/2 -translate-x-1/2 flex items-center justify-center h-12 w-12 rounded-full shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
                  style={{
                    left: `${bondingValue}%`,
                    backgroundColor: "#F6B3F6",
                  }}
                >
                  <span
                    role="img"
                    aria-label="Bonding Emoji"
                    className="text-[33px] flex items-center justify-center h-full"
                  >
                    {currentBondingSegment.icon}
                  </span>
                </div>
              </div>
            </div>

            {/* Learning Slider */}
            <div className="flex flex-col items-center w-full">
              <label className="text-[12px] leading-[16px] font-normal font-young-serif text-[#3A1A1A] mb-4">
                Learning
              </label>
              <div
                className="relative flex items-center w-full"
                onMouseDown={(e) => handleSliderMove(e, setLearningValue)}
                onTouchMove={(e) => handleSliderMove(e, setLearningValue)}
              >
                <div
                  className="absolute left-0 top-1/2 transform -translate-y-1/2 h-4 w-full rounded-full"
                  style={{
                    background: createSegmentedBackground(
                      learningValue,
                      learningSegments,
                      "rgba(96, 183, 255,"
                    ),
                  }}
                ></div>
                <input
                  type="range"
                  min="0"
                  max="100"
                  step="20"
                  value={learningValue}
                  onChange={(e) => setLearningValue(parseInt(e.target.value))}
                  className="relative appearance-none w-full h-4 bg-transparent outline-none"
  style={{ WebkitAppearance: 'none', appearance: 'none' }}
                />
                <div
                  className="absolute top-1/2 transform -translate-y-1/2 -translate-x-1/2 flex items-center justify-center h-12 w-12 rounded-full shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
                  style={{
                    left: `${learningValue}%`,
                    backgroundColor: "#60B7FF",
                  }}
                >
                  <span
                    role="img"
                    aria-label="Learning Emoji"
                    className="text-[33px]"
                  >
                    {currentLearningSegment.icon}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-[1.4rem] left-0 right-0 flex justify-center">
        <div className="relative">
          <div className="bg-white rounded-full px-8 py-2 flex space-x-12 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]">
            <button
              onClick={onBack}
              className="flex flex-col items-center text-black relative"
            >
              <IoHome className="text-2xl" />
              <span className="text-[10px] text-[#1E0A1E] font-bold mt-0.5 font-space-grotesk">
                Home
              </span>
            </button>
            <button
              onClick={onComplete}
              className="flex flex-col items-center text-gray-400"
            >
              <img
                src="/images/user-group.png"
                alt="Hub Icon"
                className="w-6 h-6"
              />
              <span className="text-[10px] mt-0.5 font-bold font-space-grotesk">
                Hub
              </span>
            </button>
          </div>
          <div className="absolute -bottom-4.5 left-1/2 transform -translate-x-1/2 w-32 h-1.5 bg-black rounded-full mt-3"></div>
        </div>
      </nav>
    </div>
  );
};

export default HomePage;
